import React, { useCallback, useMemo } from 'react';
import { ArrowTurnDownIcon, Box, Inscription } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { LetterIconSizeEnum, OrganizationTypes } from '@/common/constants';
import { Icon } from '@/components/elements/Icon/Icon';
import { useHistory } from '@/modules/core/hooks';
import formatMoneyAmountToShort from '@/utils/modifiers/formatMoneyAmountToShort';

interface Props {
  orgId?: string;
  orgName?: string;
  orgType?: OrganizationTypes;
  logoUrl?: string;
  hsaBalance?: number;
  notionalBalance?: number;
}

const BankingBalanceStatsHeader: React.FC<Props> = ({
  orgId,
  orgName,
  orgType,
  logoUrl,
  hsaBalance = 0,
  notionalBalance = 0,
}) => {
  const history = useHistory();
  const handleOnClick = useCallback(() => {
    history.push(ROUTES.BANKING_BALANCE_ORG_DETAILS(`${orgId}`)); 
  }, [history, orgId]);

  const preparedHsaBalance = useMemo(() => hsaBalance ? formatMoneyAmountToShort(hsaBalance) : '-', [hsaBalance]);
  const preparednotionalBalance = useMemo(() => notionalBalance ? formatMoneyAmountToShort(notionalBalance) : '-', [notionalBalance]);
  return (
    <Box
      data-testid="banking-balance-stats-header"
      direction="row"
      align="center"
      margin={{ bottom: 'spacing24' }}
      height="22px"
    >
      {orgName && orgType && (
        <Box
          direction="row"
          align="center"
          gap="spacing4"
          margin={{ right: 'spacing4' }}
          onClick={handleOnClick}
          style={{
            cursor: 'pointer',
          }}
        >
          <Icon
            type={orgType}
            text={orgName}
            src={logoUrl}
            size={LetterIconSizeEnum.FAV}
            width="auto"
          />
          <Inscription color="textAccent" weight="bold" size="large">
            {orgName}:
          </Inscription>
        </Box>
      )}
      <Box direction="row" gap="spacing2" align="center">
        <Inscription color="textBody" weight="bold" size="large">
          HSA {preparedHsaBalance}
        </Inscription>
        <Inscription color="textDisabled">/</Inscription>
        <Inscription color="textBody" weight="bold" size="large">
          Notional {preparednotionalBalance}
        </Inscription>
      </Box>

      <Box margin={{ left: 'spacing2' }}>
        <ArrowTurnDownIcon size="12px" color="iconSecondary" />
      </Box>
    </Box>
  );
};

export default BankingBalanceStatsHeader;
